import { Menu, Row, Col } from 'antd'
import CardProducts from '@/components/CardProducts'
import { useNavigate } from "react-router-dom";
import imgitem1 from '@/static/img/item1.png'
import imgitem2 from '@/static/img/item3.png'
import imgitem3 from '@/static/img/item4.png'
import imgBg from '@/static/img/bg_1.jpg'
import TopInfo from '@/components/TopInfo'
import React, { useEffect, useState } from 'react'
import Http from "@/utils/http";
import ConstValue from "@/utils/value";
import './index.scss'
export default function ProductsNew1() {
    const [info, setInfo] = useState({});
    const getInfo = async () => {
        let res = await Http.to.items("CLASSIFICATION/1").readByQuery({
            sort: ['id'],
            filter: { status: "published" }
        });
        setInfo(res?.data);
        console.log(info);

    }
    useEffect(()=>{
        getInfo()
    },[])
  return (
    <div className='products_new1'>
            <TopInfo imgBg={''} title={'Solution'} info1={''} info2={' '} />
        
    </div>
  )
}
